//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('shipmentContainers', {
//        templateUrl: 'views/components/views/shipmentContainers/shipmentContainers.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['utilityService', 'shipmentContainersService', 'logisticService', function (utilityService, shipmentContainersService, logisticService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
            
//            vm.model = {
//                setting: {},
//                selectListCompanies: [],
//                selectListStockPlaces: [],
//                selectListStatuses: [],
//                itemsListContainers: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTIONS

//            async function loadSetting() {
//                vm.model.setting = (await shipmentContainersService.getSetting())[0];
//            }
            
//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            }

//            async function loadStatuses() {
//                vm.model.selectListStatuses = await shipmentContainersService.listStatuses();
//            }

//            async function loadStockPlaces() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no_to, true) !== true) return;
                
//                return vm.model.selectListStockPlaces = await logisticService.listStocks({ businessco_no: vm.model.setting.businessco_no_to });
//            }
            
//            async function loadShipmentContainers() {
//                if (utilityService.validateParmsValue(vm.model.setting.businessco_no_to, true) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.stockplace_id_to, true) !== true) return;
//                if (utilityService.validateParmsValue(vm.model.setting.shipmentcontainerstatus_keyno, true) !== true) return;

//                return vm.model.itemsListContainers = await shipmentContainersService.listContainers(vm.model.setting);
//            }

//            // #endregion LOAD PROCEDURE FUNCTIONS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'businessco_no_to':
//                        if (utilityService.validateWatchValue(value, vm.model.setting.businessco_no_to) !== true) return;

//                        vm.model.setting.businessco_no_to = value;

//                        if (utilityService.validateParmsValue(vm.model.setting.businessco_no_to, true) !== true) return;

//                        loadStockPlaces();
//                        loadShipmentContainers();
//                        break;
//                    case 'stockplace_id_to':
//                    case 'shipmentcontainerstatus_keyno':
//                        if (utilityService.validateWatchValue(value, vm.model.setting[id]) !== true) return;

//                        vm.model.setting[id] = value;

//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        loadShipmentContainers();
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                await loadSetting();
//                loadCompanies();
//                loadStatuses();
//                loadStockPlaces();
//                loadShipmentContainers();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
